import { Component, OnInit } from '@angular/core';
import { HomeService } from '../../../../services/home.service';
import { UserService } from '../../../../services/user';
import { AttendanceService } from '../../../../services/attendance';
import { DeviceDetectorService } from 'ngx-device-detector';
import { UserInterface } from '../../../../interfaces/user-interface';
import { BarcodeFormat } from '@zxing/library';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-fingerprintmobile',
  templateUrl: './fingerprintmobile.component.html',
  styleUrl: './fingerprintmobile.component.scss'
})
export class FingerprintmobileComponent implements OnInit {

  selectedYear!: number;
  selectedMonth!: string;
  selectedUserId!: any;

  years: number[] = [];

  months = [
    { value: '01', name_ar: 'يناير', name_en: 'January' },
    { value: '02', name_ar: 'فبراير', name_en: 'February' },
    { value: '03', name_ar: 'مارس', name_en: 'March' },
    { value: '04', name_ar: 'أبريل', name_en: 'April' },
    { value: '05', name_ar: 'مايو', name_en: 'May' },
    { value: '06', name_ar: 'يونيو', name_en: 'June' },
    { value: '07', name_ar: 'يوليو', name_en: 'July' },
    { value: '08', name_ar: 'أغسطس', name_en: 'August' },
    { value: '09', name_ar: 'سبتمبر', name_en: 'September' },
    { value: '10', name_ar: 'أكتوبر', name_en: 'October' },
    { value: '11', name_ar: 'نوفمبر', name_en: 'November' },
    { value: '12', name_ar: 'ديسمبر', name_en: 'December' }
  ];

  attendanceData: any[] = [];

  QrOption: boolean = false;
  contentReady: boolean = true;

  userId!: any;
  accountType!: any;

  isAr: boolean = false;
  isAdmin: boolean = false;
  hasaccess: boolean = false;

  hasCheckedIn: boolean = false;
  hasCheckedOut: boolean = false;
  canCheckIn: boolean = true;

  allUsers: UserInterface[] = [];
  qrList: any[] = [];
  generatedQr: any;

  scanMode: boolean = false;
  allowedFormats = [BarcodeFormat.QR_CODE];

  constructor(
    private _userService: UserService,
    private _homeService: HomeService,
    private attendanceService: AttendanceService,
    private deviceService: DeviceDetectorService
  ) {
    const today = new Date();

    this.selectedYear = today.getFullYear();
    this.selectedMonth = (today.getMonth() + 1).toString().padStart(2, '0');

    for (let y = 2015; y <= 2030; y++) {
      this.years.push(y);
    }

    this.isAr = this.getStorageItem('language') === 'ar';
  }

  ngOnInit(): void {
    this.getUserData();
    this.getAccountType();
  }

  getUserData(): void {
    this.contentReady = true;

    this._userService.getUserId().subscribe({
      next: (data) => {
        this.userId = data['user_id'];
        this.selectedUserId = this.userId;

        this.checkInStatus();
        this.loadAttendance();
        this.loadQrCodes();
      },
      error: (error) => {
        this.contentReady = false;
        console.error(error);
      }
    });
  }

  getAccountType(): void {
    this._userService.getAccountType().subscribe({
      next: (data) => {
        this.accountType = data['user_type'];

        this.isAdmin =
          this.accountType == '1' ||
          this.accountType == '10';

        this.hasaccess =
          this.accountType == '1' ||
          this.accountType == '6' ||
          this.accountType == '10';

        if (this.hasaccess) {
          this.getAllUsers();
        }
      },
      error: (error) => console.error(error)
    });
  }

  checkInStatus(): void {
    this.contentReady = true;

    this.attendanceService.getTodayCheckinStatus().subscribe({
      next: (res) => {
        this.hasCheckedIn = res.checked_in;
        this.hasCheckedOut = res.checked_out;
        this.canCheckIn = !(this.hasCheckedIn && this.hasCheckedOut);
        this.contentReady = false;
      },
      error: (error) => {
        this.contentReady = false;
        console.error(error);
      }
    });
  }

  getLocationAndCheck(type: 'in' | 'out'): void {
    this.contentReady = true;

    const deviceInfo = this.deviceService.getDeviceInfo();
    const deviceTime = new Date().toTimeString().split(' ')[0];
    const serverTime = new Date().toISOString();

    if (!('geolocation' in navigator)) {
      this.contentReady = false;
      Swal.fire('❌', 'المتصفح لا يدعم تحديد الموقع', 'error');
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const latitude = position.coords.latitude;
        const longitude = position.coords.longitude;

        const payload =
          type === 'in'
            ? {
                check_in_latitude: latitude,
                check_in_longitude: longitude,
                check_in_device_time: deviceTime,
                check_in_server_time: serverTime,
                device_info: JSON.stringify(deviceInfo),
                location_access_denied: 0
              }
            : {
                check_out_latitude: latitude,
                check_out_longitude: longitude,
                check_out_device_time: deviceTime,
                check_out_server_time: serverTime,
                device_info: JSON.stringify(deviceInfo),
                location_access_denied: 0
              };

        this.submitAttendance(type, payload, false);
      },
      () => {
        const payload =
          type === 'in'
            ? {
                check_in_device_time: deviceTime,
                check_in_server_time: serverTime,
                device_info: JSON.stringify(deviceInfo),
                location_access_denied: 1
              }
            : {
                check_out_device_time: deviceTime,
                check_out_server_time: serverTime,
                device_info: JSON.stringify(deviceInfo),
                location_access_denied: 1
              };

        this.submitAttendance(type, payload, true);
      }
    );
  }

  submitAttendance(type: 'in' | 'out', payload: any, withoutLocation: boolean): void {
    const request =
      type === 'in'
        ? this.attendanceService.checkIn(payload)
        : this.attendanceService.checkOut(payload);

    request.subscribe({
      next: () => {
        this.contentReady = false;

        const title = withoutLocation ? '⚠️' : '✔️';

        const message =
          type === 'in'
            ? (withoutLocation ? 'تم تسجيل الحضور بدون موقع' : 'تم تسجيل الحضور')
            : (withoutLocation ? 'تم تسجيل الانصراف بدون موقع' : 'تم تسجيل الانصراف');

        const icon = withoutLocation ? 'warning' : 'success';

        Swal.fire(title, message, icon).then(() => {
          this.checkInStatus();
          this.loadAttendance();
        });
      },
      error: () => {
        this.contentReady = false;

        Swal.fire(
          '❌',
          type === 'in' ? 'فشل تسجيل الحضور' : 'فشل تسجيل الانصراف',
          'error'
        );
      }
    });
  }

  loadAttendance(): void {
    const id = this.selectedUserId || this.userId;

    if (!id) {
      this.contentReady = false;
      return;
    }

    this.contentReady = true;

    this.attendanceService
      .getMonthlyAttendance(id, this.selectedMonth, String(this.selectedYear))
      .subscribe({
        next: (res) => {
          this.attendanceData = res.data || [];
          this.contentReady = false;
        },
        error: (error) => {
          this.contentReady = false;
          console.error(error);
        }
      });
  }

  getAllUsers(): void {
    this.contentReady = true;

    this._homeService.getAllUsers().subscribe({
      next: (data) => {
        this.allUsers = data.filter((user: any) => user.type != 2 && user.type != 9);
        this.contentReady = false;
      },
      error: (error) => {
        this.contentReady = false;
        console.error(error);
      }
    });
  }

  userFilter(id: any): void {
    this.selectedUserId = id;
    this.loadAttendance();
  }

  extractDeviceInfo(deviceInfoString: string): string {
    if (!deviceInfoString) return '-';

    try {
      const data = JSON.parse(deviceInfoString);

      return `${data.deviceType || '-'} | ${data.device || '-'} | ${data.browser || '-'} | ${data.os_version || '-'}`;
    } catch {
      return '-';
    }
  }

  calculateDiff(inTime: string, outTime: string): string {
    if (!inTime || !outTime) return '-';

    const [inHours, inMinutes] = inTime.split(':').map(Number);
    const [outHours, outMinutes] = outTime.split(':').map(Number);

    const inDate = new Date();
    inDate.setHours(inHours, inMinutes, 0, 0);

    const outDate = new Date();
    outDate.setHours(outHours, outMinutes, 0, 0);

    const diffMs = outDate.getTime() - inDate.getTime();

    if (diffMs < 0) return '-';

    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
    const diffMinutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

    return this.isAr
      ? `${diffHours} ساعة ${diffMinutes} دقيقة`
      : `${diffHours} hours ${diffMinutes} minutes`;
  }

  loadQrCodes(): void {
    this.contentReady = true;

    this.attendanceService.getAllQrTokens(this.getPosId()).subscribe({
      next: (res) => {
        this.qrList = res || [];
        this.contentReady = false;
      },
      error: (error) => {
        this.contentReady = false;
        console.error(error);
      }
    });
  }

  generateQr(): void {
    this.contentReady = true;

    this.attendanceService
      .generateQr({
        warehouse_id: this.getPosId(),
        type: 'check_in'
      })
      .subscribe({
        next: (res) => {
          this.generatedQr = res.qr_code;
          this.contentReady = false;
          this.loadQrCodes();
        },
        error: () => {
          this.contentReady = false;
          Swal.fire('❌', 'المخزن ده عليه كيواركود', 'error');
        }
      });
  }

  deleteQr(id: any): void {
    this.contentReady = true;

    this.attendanceService.deleteQr(id).subscribe({
      next: () => {
        this.contentReady = false;

        Swal.fire('✅', 'تم حذف الكيواركود بنجاح', 'success').then(() => {
          this.loadQrCodes();
        });
      },
      error: () => {
        this.contentReady = false;
        Swal.fire('❌', 'فشل حذف الكيواركود', 'error');
      }
    });
  }

  fixImageUrl(image: string): string {
    if (!image) return '';

    const fileName = image.split('/').pop();

    return 'https://backendproduction.blueboxpet.com/storage/app/public/qrcodes/' + fileName;
  }

  downloadQr(url: string): void {
    const fileName = url.split('/').pop() || 'qr-code.png';

    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  onCodeResult(result: string): void {
    this.contentReady = true;
    this.scanMode = false;

    try {
      const parsed = JSON.parse(result);

      if (!parsed?.token) {
        this.contentReady = false;
        Swal.fire('❌', 'Invalid QR Format', 'error');
        return;
      }

      this.attendanceService
        .validateQr({
          token: parsed.token,
          warehouse_id: this.getStorageItem('posId')
        })
        .subscribe({
          next: () => {
            if (!this.hasCheckedIn) {
              this.getLocationAndCheck('in');
            } else if (this.hasCheckedIn && !this.hasCheckedOut) {
              this.getLocationAndCheck('out');
            } else {
              this.contentReady = false;
              Swal.fire('ℹ️', 'لقد قمت بالفعل بتسجيل الحضور والانصراف اليوم', 'info');
            }
          },
          error: () => {
            this.contentReady = false;
            Swal.fire('❌', 'Invalid QR Code', 'error');
          }
        });
    } catch {
      this.contentReady = false;
      Swal.fire('❌', 'Invalid QR Format', 'error');
    }
  }

  private getStorageItem(key: string): string {
    if (typeof window === 'undefined') return '';

    return localStorage.getItem(key) || '';
  }

  private getPosId(): number {
    return parseInt(this.getStorageItem('posId') || '0', 10);
  }
}